import { AcceptedCurrencyCode } from '../../types/__generated-graphQL__';

const FALLBACK_CURRENCY_CODE = AcceptedCurrencyCode.Gbp;

export const formatCurrencySymbol = (currencyCode?: AcceptedCurrencyCode) => {
  switch (currencyCode ?? FALLBACK_CURRENCY_CODE) {
    case AcceptedCurrencyCode.Gbp:
      return '£';
    case AcceptedCurrencyCode.Usd:
    case AcceptedCurrencyCode.Cad:
    case AcceptedCurrencyCode.Aud:
    case AcceptedCurrencyCode.Nzd:
      return '$';
    case 'EUR':
      return '€';
    default:
      return '£';
  }
};

export type CurrencyFormatOptions = {
  currencyCode?: AcceptedCurrencyCode;
  amount: number;
  alwaysShowFractions?: boolean;
};

export const formatCurrency = ({
  currencyCode,
  amount,
  alwaysShowFractions = false,
}: CurrencyFormatOptions) => {
  return new Intl.NumberFormat(navigator?.language, {
    style: 'currency',
    currency: currencyCode ?? FALLBACK_CURRENCY_CODE,
    ...(!alwaysShowFractions && amount % 1 === 0
      ? { minimumFractionDigits: 0, maximumFractionDigits: 0 }
      : { minimumFractionDigits: 2 }),
  }).format(amount);
};
